import { render } from "./DocumentsModal.vue?vue&type=template&id=630e661c"
import script from "./DocumentsModal.vue?vue&type=script&lang=js"
export * from "./DocumentsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__